import { BREAKPOINT_LG, BREAKPOINT_MD } from './constants'

type Breakpoints = 'sm' | 'md' | 'lg'

const breakpoints: Array<[Breakpoints, number]> = [
  ['md', BREAKPOINT_MD],
  ['lg', BREAKPOINT_LG],
]

/**
 * @param availableWidth The available width for the breakpoint calculation
 * @returns The active breakpoint string ('sm', 'md', 'lg') based on available width.
 * @usage getActiveBreakpoint(900) returns 'md'
 */
export function getActiveBreakpoint(availableWidth: number): Breakpoints {
  return breakpoints.reduce((previousBreakpoint, [breakpoint, width]) => {
    return availableWidth >= width ? breakpoint : previousBreakpoint
  }, 'sm')
}
